<template>
  <CRow class="ml-0 mr-0 mt-5 h-100">
    <CCol lg="7" sm="12" xl="7">
      <img v-if="data.content.item != undefined" :src="this.baseUrl + '/cpr/Image/' + data.content.item[0].data" class="w-100 mt-5"/>
    </CCol>
    <CCol class="mt-md-3 pl-lg-5" lg="5" sm="12" xl="5">
      <CRow class="mt-5 w-100" v-if="data.content.title">
        <CCol class="text-left">
          <span class="preview-title "> {{$helpers.translate(data.content.title, lang)}}</span>
          <a class="float-right close-preview" @click="onAction(data.navigate.previous.action)"><font-awesome-icon :icon="['fas', 'times']" /></a>
        </CCol>
      </CRow>
      <CRow class="mt-3 w-100" v-if="data.content.title">
        <CCol class="preview-desc">
          {{$helpers.translate(data.content.description, lang)}}
        </CCol>
      </CRow>
      <CRow class="buttonPreview mt-md-3 mb-md-3">
        <CCol class="text-center">
          <CButton class="btn btn-cpr btn-secondary" @click="onAction(data.navigate.previous.action)">
            {{$helpers.translate(data.navigate.previous.title, lang)}}
          </CButton>
          <CButton class="btn btn-cpr btn-primary" @click="onAction(data.navigate.next.action)">
            {{$helpers.translate(data.navigate.next.title, lang)}}
          </CButton>
        </CCol>
      </CRow>
    </CCol>
  </CRow>
</template>
<script>
export default {
  name: "PreviewComponent",
  props: {
    data: Object
  },
  data() {
    return {
      lang: "th",
      baseUrl: process.env.VUE_APP_URL_SOUND,
    }
  },
  methods: {
    onAction(action){
      
      this.$router.push({name: action})
    }
  },
  mounted() {
    //this.windowWidth = window.innerWidth
  }
}
</script>

<style scoped>
img {
  box-shadow: 10px 10px 10px #00000029;
  opacity: 1;
}
.close-preview{
  font-size: 16px;
  cursor: pointer;
}
.close-preview:hover{
  opacity: 0.8;
}
.preview-title {
  text-transform: uppercase;
  font: normal normal medium 30px/39px Roboto;
  color: #000000;
  font-weight: 500;
  text-align: left;
  font-size: 24px;
  font-family: Roboto;
  letter-spacing: 1px;
  opacity: 1;
}
.preview-desc{
  font-size: 25px;
  font-weight: 300;
}
.buttonPreview {
  bottom: 0;
  position: absolute;
  justify-content: center;
  width: 100%;
}

@media only screen and (max-width: 1200px) and (min-width: 240px) {
  .buttonPreview {
    bottom: 0;
    position: revert;
    justify-content: center;
  }
}

@media only screen and (max-width: 1600px) and (min-width: 1201px) {
  .buttonPreview {
    bottom: 0;
    position: revert;
    justify-content: center;
    left: 40%;
    padding-top: 3rem;
  }
}
</style>